const useStyles = () => {
	return {
		containerFooter: 'text-white flex justify-center m-4 ',
		pFooter:
			'flex text-sm items-center ring-2 px-1 py-1 rounded-full hover:bg-indigo-800',
		spanFooter: 'px-1',
	};
};

export default useStyles;
